export const INVESTMENT_LEAGUE_TABS = [
  { id: "investment-summary",    label: "Investment Summary" },
  { id: "jackpot-status",        label: "Jackpot Status"     },
  { id: "recipient-leaderboard", label: "Investment Recipient Leaderboard" },
  { id: "reinvest-q3",           label: "Re-Invest for Q3"   },
];

export const INVESTMENT_LEAGUE_TABS_ROLE_BASE = [
  { id: "leaderboard",           label: "Overall Leaderboard" },
  { id: "investment-summary",    label: "Investment Summary" },
  { id: "jackpot-status",        label: "Jackpot Status"     },
  { id: "recipient-leaderboard", label: "Investment Recipient Leaderboard" },
  { id: "reinvest-q3",           label: "Re-Invest for Q3"   },
];

export const INVESTMENT_LEAGUE_ADMIN_EMAILS = [
  "mohammad.faazil@psiog.com",
  "sindhu.zaddu@psiog.com",
  "srivathsan.santhanam@psiog.com",
  "sivakumar.vaidyanathan@psiog.com",
  "kumar.sivaraman@psiog.com",
  "bharathi.subramani@psiog.com"
];

export const isInvestmentLeagueAdmin = (email) =>
  INVESTMENT_LEAGUE_ADMIN_EMAILS.includes(email?.toLowerCase());

export const OVERALL_LEADERBOARD_METRICS = [
  {
    label:    "Total Pool Value",
    value:    "$11.58M",
    sub:      "+$582,000",
    subColor: "positive",
  },
  {
    label:    "Average Return",
    value:    "+5.29%",
    sub:      "Across 11 units",
    subColor: "neutral",
    valueColor: "positive",
  },
  {
    label:    "Top Investor",
    value:    "MAC 5",
    sub:      "+14.2% all-time",
    subColor: "positive",
  },
  {
    label:    "Jackpot Eligible",
    value:    "2 of 11",
    sub:      "MAC 5 & SRG — 10/10 green",
    subColor: "neutral",
  },
  {
    label:    "As Of",
    value:    "Q1 Close",
    sub:      "Next rebalance: Q2",
    subColor: "neutral",
  },
];

export const LEAGUE_STANDINGS = [
  { rank: 1,  unit: "MAC 5 - Vega",                         invested: 1000000, q1Credit: 1142000, current: 1142000, allTimeReturn: 14.20, qtrReturn: 3.29,  draw: 0,  highlight: "top"    },
  { rank: 2,  unit: "MAC 3 - Polaris",                      invested: 1000000, q1Credit: 1128000, current: 1128000, allTimeReturn: 12.80, qtrReturn: 2.95,  draw: 0,  highlight: null     },
  { rank: 3,  unit: "SRG - Solutions & Revenue Group",      invested: 1000000, q1Credit: 1115000, current: 1115000, allTimeReturn: 11.50, qtrReturn: 2.70,  draw: 0,  highlight: null     },
  { rank: 4,  unit: "TSG - Technology Services Group",      invested: 1000000, q1Credit: 1098000, current: 1098000, allTimeReturn: 9.80,  qtrReturn: 2.10,  draw: 0,  highlight: null     },
  { rank: 5,  unit: "MAC 7 - Draco",                        invested: 1000000, q1Credit: 1085000, current: 1085000, allTimeReturn: 8.50,  qtrReturn: 1.85,  draw: 0,  highlight: null     },
  { rank: 6,  unit: "MAC 8 - Scorpius",                     invested: 1000000, q1Credit: 1072000, current: 1072000, allTimeReturn: 7.20,  qtrReturn: 1.50,  draw: 0,  highlight: null     },
  { rank: 7,  unit: "MAC 4 - Andromeda",                    invested: 1000000, q1Credit: 1058000, current: 1058000, allTimeReturn: 5.80,  qtrReturn: 1.20,  draw: 0,  highlight: null     },
  { rank: 8,  unit: "MAC 6 - Sirius",                       invested: 1000000, q1Credit: 1042000, current: 1042000, allTimeReturn: 4.20,  qtrReturn: 0.95,  draw: 0,  highlight: null     },
  { rank: 9,  unit: "MAC 1 - Arcturus",                     invested: 1000000, q1Credit: 1028000, current: 1028000, allTimeReturn: 2.80,  qtrReturn: 0.60,  draw: 0,  highlight: null     },
  { rank: 10, unit: "MAC 2 - Hercules",                     invested: 1000000, q1Credit: 998000,  current: 998000,  allTimeReturn: -0.20, qtrReturn: -0.15, draw: 0,  highlight: null     },
  { rank: 11, unit: "SCG - Skills & Competencies Group",    invested: 1000000, q1Credit: 962000,  current: 962000,  allTimeReturn: -3.80, qtrReturn: -0.95, draw: 0,  highlight: "bottom" },
];

export const SUMMARY_METRICS = [
  {
    label:    "Current Value",
    value:    "$1,032,920",
    sub:      "+$32,920",
    subColor: "positive",
  },
  {
    label:    "Invested (Cost)",
    value:    "$1,000,000",
    sub:      "Across 10 holdings",
    subColor: "neutral",
  },
  {
    label:    "All-Time Return",
    value:    "+3.29%",
    sub:      "+ Green Base",
    subColor: "positive",
  },
  {
    label:    "Q1 Return",
    value:    "+3.29%",
    sub:      "Latest quarter",
    subColor: "neutral",
  },
  {
    label:    "IRR (Annualized)",
    value:    "13.8%",
    sub:      "Projected from Q1 performance",
    subColor: "neutral",
  },
];

export const PORTFOLIO_TREND_DATA = [
  { quarter: "Q0", value: 1000000 },
  { quarter: "Q1", value: 1032920 },
];

export const HOLDINGS = [
  { ticker: "MAC 3", name: "Polaris",              invested: 150000, current: 177600, returns: 27600,  returnsPct: 18.4,  positive: true  },
  { ticker: "MAC 5", name: "Vega",                 invested: 100000, current: 111800, returns: 11800,  returnsPct: 11.8,  positive: true  },
  { ticker: "SDI",   name: "Solutions & Revenue",  invested: 100000, current: 109000, returns: 9000,   returnsPct: 9.0,   positive: true  },
  { ticker: "MAC 7", name: "Draco",                invested: 100000, current: 104000, returns: 4000,   returnsPct: 4.0,   positive: true  },
  { ticker: "MAC 8", name: "Scorpius",             invested: 100000, current: 101500, returns: 1500,   returnsPct: 1.5,   positive: true  },
  { ticker: "MAC 6", name: "Sirius",               invested: 100000, current: 98500,  returns: -1500,  returnsPct: -1.5,  positive: false },
  { ticker: "MAC 4", name: "Andromeda",            invested: 100000, current: 97000,  returns: -3000,  returnsPct: -3.0,  positive: false },
  { ticker: "SDI",   name: "Skills & Competencies", invested: 100000, current: 94000,  returns: -6000,  returnsPct: -6.0,  positive: false },
  { ticker: "MAC 2", name: "Hercules",             invested: 100000, current: 93000,  returns: -7000,  returnsPct: -7.0,  positive: false },
  { ticker: "TSG",   name: "Technology Services",  invested: 100000, current: 94000,  returns: -6000,  returnsPct: -6.0,  positive: false },
];

export const BASE_PICKS = [
  { label: "MAC 3", sub: "Polaris",               value: "+18.4%", positive: true  },
  { label: "MAC 5", sub: "Vega",                  value: "+11.8%", positive: true  },
  { label: "SDI",   sub: "Solutions & Revenue",   value: "+9.0%",  positive: true  },
  { label: "MAC 7", sub: "Draco",                 value: "+4.0%",  positive: true  },
  { label: "MAC 8", sub: "Scorpius",              value: "+1.5%",  positive: true  },
  { label: "MAC 6", sub: "Sirius",                value: "-1.5%",  positive: false },
  { label: "MAC 4", sub: "Andromeda",             value: "-3.0%",  positive: false },
  { label: "SDI",   sub: "Skills & Competencies", value: "-6.0%",  positive: false },
  { label: "MAC 2", sub: "Hercules",              value: "-7.0%",  positive: false },
  { label: "TSG",   sub: "Technology Services",   value: "-6.0%",  positive: false },
];

export const JACKPOT_LEADERBOARD = [
  { rank: 1,  unit: "MAC 5 - Vega",              green: 10, total: 10, roi: 8.4,  status: "eligible" },
  { rank: 2,  unit: "MAC 3 - Polaris",           green: 10, total: 10, roi: 7.1,  status: "eligible" },
  { rank: 3,  unit: "MAC 7 - Draco",             green: 9,  total: 10, roi: 5.8,  status: null       },
  { rank: 4,  unit: "MAC 8 - Scorpius",          green: 9,  total: 10, roi: 4.2,  status: null       },
  { rank: 5,  unit: "SDI - Solutions & Revenue", green: 8,  total: 10, roi: 3.9,  status: null       },
  { rank: 6,  unit: "MAC 4 - Andromeda",         green: 8,  total: 10, roi: 2.1,  status: null       },
  { rank: 7,  unit: "MAC 6 - Sirius",            green: 7,  total: 10, roi: 1.4,  status: null       },
  { rank: 8,  unit: "MAC 1 - Arcturus",          green: 6,  total: 10, roi: 3.2,  status: null, isYou: true },
  { rank: 9,  unit: "MAC 2 - Hercules",          green: 5,  total: 10, roi: -1.2, status: null       },
  { rank: 10, unit: "TSG - Technology Services", green: 4,  total: 10, roi: -2.8, status: null       },
  { rank: 11, unit: "SDI - Skills & Competencies", green: 3, total: 10, roi: -4.5, status: null     },
];

export const IL_COLORS = {
  positive: "#2D8A5B",
  negative: "#D9534F",
  positiveBg: "rgba(45,138,91,0.10)",
  negativeBg: "rgba(217,83,79,0.10)",
  chart: "#008080",
  chartFill: "rgba(0,128,128,0.12)",
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style:    "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);

export const formatSignedCurrency = (value) => {
  const prefix = value >= 0 ? "+" : "";
  return prefix + formatCurrency(value);
};

export const formatSignedPercent = (value) => {
  if (value == null || isNaN(value)) return "-";
  const prefix = value >= 0 ? "+" : "";
  return `${prefix}${Number(value).toFixed(1)}%`;
};

export const RECIPIENT_MAC_UNITS = [
  "MAC 1 - Arcturus",
  "MAC 2 - Hercules",
  "MAC 3 - Polaris",
  "MAC 4 - Andromeda",
  "MAC 5 - Vega",
  "MAC 6 - Sirius",
  "MAC 7 - Draco",
  "MAC 8 - Scorpius",
];

export const RECIPIENT_GROUP_UNITS = [
  "TSG",
  "SRG",
  "SCG",
];

export const ALL_RECIPIENT_UNITS = [
  ...RECIPIENT_MAC_UNITS,
  ...RECIPIENT_GROUP_UNITS,
];

export const RECIPIENT_CHART_COLORS = {
  macBar: "#00D492",
  groupBar: "#38BDF8",
  q1: "#3B82F6", // Blue
  q2: "#10B981", // Teal / Emerald
  q3: "#F59E0B", // Amber / Gold
  q4: "#EF4444", // Coral / Red
};

export const REINVESTMENT_MOCK_PREVIEW = {
  investorUnit: "MAC 2 - Hercules",
  previousQuarter: "Q2",
  upcomingQuarter: "Q3",
  availableCredit: 944105.00,
  allocatedAmount: 0,
  remainingCredit: 944105.00,
  window: {
    start: "2026-09-01",
    end: "2026-10-31",
    isOpen: true,
  },
  jackpot: {
    eligible: false,
    status: "AT_RISK",
    requiredPreviousUnits: [
      "MAC 3 - Polaris",
      "MAC 6 - Sirius",
      "MAC 7 - Draco",
      "MAC 8 - Scorpius",
      "SCG",
      "SRG",
    ],
    missingUnits: [
      "MAC 3 - Polaris",
      "MAC 6 - Sirius",
      "MAC 7 - Draco",
      "MAC 8 - Scorpius",
      "SCG",
      "SRG",
    ],
    message: "No investments allocated for the upcoming quarter.",
  },
  allocations: [
    {
      buUnit: "MAC 1 - Arcturus",
      type: "MAC",
      previousQuarterInvestment: 0,
      previousQuarterReturn: 0,
      previousQuarterRoi: null,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: false,
      requiredForJackpot: false,
      currentQuarterInvestment: 0,
      status: "NOT_INVESTED",
    },
    {
      buUnit: "MAC 3 - Polaris",
      type: "MAC",
      previousQuarterInvestment: 10000.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
    {
      buUnit: "MAC 4 - Andromeda",
      type: "MAC",
      previousQuarterInvestment: 0,
      previousQuarterReturn: 0,
      previousQuarterRoi: null,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: false,
      requiredForJackpot: false,
      currentQuarterInvestment: 0,
      status: "NOT_INVESTED",
    },
    {
      buUnit: "MAC 5 - Vega",
      type: "MAC",
      previousQuarterInvestment: 0,
      previousQuarterReturn: 0,
      previousQuarterRoi: null,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: false,
      requiredForJackpot: false,
      currentQuarterInvestment: 0,
      status: "NOT_INVESTED",
    },
    {
      buUnit: "MAC 6 - Sirius",
      type: "MAC",
      previousQuarterInvestment: 10000.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
    {
      buUnit: "MAC 7 - Draco",
      type: "MAC",
      previousQuarterInvestment: 10000.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
    {
      buUnit: "MAC 8 - Scorpius",
      type: "MAC",
      previousQuarterInvestment: 10000.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
    {
      buUnit: "TSG",
      type: "Group",
      previousQuarterInvestment: 0,
      previousQuarterReturn: 0,
      previousQuarterRoi: null,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: false,
      requiredForJackpot: false,
      currentQuarterInvestment: 0,
      status: "NOT_INVESTED",
    },
    {
      buUnit: "SRG",
      type: "Group",
      previousQuarterInvestment: 894105.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
    {
      buUnit: "SCG",
      type: "Group",
      previousQuarterInvestment: 10000.00,
      previousQuarterReturn: 0.00,
      previousQuarterRoi: 0,
      cumulativeVariance: 0.00000,
      investedInPreviousQuarter: true,
      requiredForJackpot: true,
      currentQuarterInvestment: 0,
      status: "AT_RISK",
    },
  ],
};

export const REINVESTMENT_MOCK_CREDIT_VALIDATION = {
  investorUnit: "MAC 2 - Hercules",
  previousQuarter: "Q2",
  upcomingQuarter: "Q3",
  previousQuarterCredit: 944105.00,
  allocatedAmount: 0,
  remainingCredit: 944105.00,
  allocationPercentage: 0,
  isFullyAllocated: false,
  isOverAllocated: false,
  isValid: true,
};

export const REINVESTMENT_MOCK_SCREEN_CONSTRAINT = {
  screenName: "Re-invest for Q3",
  openAccess: false,
};

